import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

/** Asia/Ulaanbaatar is a fixed +08:00 (no DST). */
const UB_OFFSET_MINUTES = 480;

/** Exact UTC clock of legacy moment().endOf("month") on a UTC host (backend LEGACY_UTC_EOM_TIME). */
const LEGACY_UTC_EOM_TIME = "23:59:59.999";

const DAY = "YYYY-MM-DD";

/**
 * Business due calendar day of a stored `payment_date` (naive UTC timestamp).
 * Mirrors de-invoice-service `utils/ub-calendar.ts` dueDay():
 *  - legacy EOM instant (`…T23:59:59.999Z`) -> the UTC date;
 *  - everything else (UB end-of-day `…T15:59:59.999Z`, UB wall-clock writers) -> the UB date.
 * A bare «YYYY-MM-DD» is already a calendar day and is returned as is.
 */
export function dueDay(paymentDate: string | Date | null | undefined): string | null {
  if (paymentDate == null || paymentDate === "") return null;
  if (typeof paymentDate === "string" && /^\d{4}-\d{2}-\d{2}$/.test(paymentDate.trim())) {
    return paymentDate.trim();
  }
  const instant = dayjs.utc(paymentDate);
  if (!instant.isValid()) return null;
  if (instant.format("HH:mm:ss.SSS") === LEGACY_UTC_EOM_TIME) return instant.format(DAY);
  return instant.utcOffset(UB_OFFSET_MINUTES).format(DAY);
}

/** Today's calendar day in Ulaanbaatar. */
export function ubToday(now: Date = new Date()): string {
  return dayjs.utc(now).utcOffset(UB_OFFSET_MINUTES).format(DAY);
}

/** Calendar days from today (UB) to the due day; negative = overdue, null = no date. */
export function daysUntilDue(paymentDate: string | Date | null | undefined, now: Date = new Date()): number | null {
  const due = dueDay(paymentDate);
  if (!due) return null;
  return dayjs.utc(due, DAY).diff(dayjs.utc(ubToday(now), DAY), "day");
}
